const max = (arr, identifer = 'id') => {
  if (!arr.length) return false
  return Math.max(...arr.map((i) => i[identifer]))
}

const updateObjectProperty = (array, key, prop, newProp) => {
  const isFind = [...array].find(item => item[key] === prop)
  if (isFind) {
    isFind[key] = newProp
  }
  return array
}

const deepCopyArray = (arr) => {
  return arr.map(elm => ({ ...elm }))
}

const percentage = (partialValue, totalValue) => {
  return ((100 * partialValue) / totalValue).toFixed(2)
} 

const sum = (objOrArr, old = 0) => {
  // const looper = Array.isArray(objOrArr) ? Object.entries({ ...objOrArr }) : Object.entries(objOrArr)
  return Object.entries({ ...objOrArr }).reduce((acumu, [key, value]) => {
    if (typeof value === 'object' && value !== null) {
      return sum(value, acumu)
    } else if (value && key === 'value' && typeof value === 'number') {
      acumu = acumu + value
    }
    return acumu
    // this.array.reduce((accum,item) => accum + item.children, 0)
  }, old)
}

const arrayUniqueByKey = (arr, key) => {
  return [...new Map(arr.map(item => [item[key], item])).values()]
}
const fluck = (arr, keyNeed, valueNeed) => {
  return arrayUniqueByKey(deepCopyArray(arr).map(item => {
    const obj = {}
    obj.key = item[keyNeed]
    obj.value = item[valueNeed]
    return obj
  }), 'key')
}

const groupBy = (arr) => {
  const result = Object.entries([...arr].reduce((acc, value) => {
    if (value.multiPolygon) delete value.multiPolygon
    if (value.group_name) {
      if (!acc[value.group_name]) {
        acc[value.group_name] = []
      }
      acc[value.group_name].push(value)
    }
    return acc
  }, {})).map(([name, data]) => ({ name, data }))
  return result
}

export {
  max,
  updateObjectProperty,
  deepCopyArray,
  groupBy,
  fluck,
  sum,
  percentage
}

